import { type FC } from 'react';
import authModalLoader from 'dibs-buyer-layout/src/utils/AuthModalLoader';
import { RecentlyViewedItemsLazy } from 'dibs-recent-history/exports/RecentlyViewedItemsLazy';
import classnames from 'classnames';

import {
    trackViewMoreClick,
    trackItemClick,
    trackItemImpression,
} from 'dibs-recent-history/exports/recentHistoryTracking';
import { trackModule, trackModuleLocation } from '../helpers/moduleLocationTracking';
import { trackInitialDisplay } from '../helpers/carouselTracking';
import { useCurrency } from 'dibs-buyer-layout/exports/useCurrency';
import { useHomePageContext } from '../HomePageContext';

import dibsCss from 'dibs-css';
import styles from './HpSharedRecentlyViewedItems.scss';

const ACTION_LABEL = 'recently viewed';
const TRACKING_TITLE = 'Recently Viewed';

export const HpSharedRecentlyViewedItems: FC<{
    moduleIndex: number;
    totalModules: number;
    isMobile: boolean;
}> = ({ moduleIndex, totalModules, isMobile }) => {
    const { currency } = useCurrency();
    const { isBot, isTopDisplayAdEnabled } = useHomePageContext();

    return (
        <RecentlyViewedItemsLazy
            centerTitle
            isMobile={isMobile}
            wrapperClassName={classnames(
                isTopDisplayAdEnabled ? dibsCss.mtMedium : styles.recentlyViewed,
                {
                    'primary-viewport-width': isMobile,
                }
            )}
            authModalLoader={authModalLoader}
            actionLabel={ACTION_LABEL}
            trackViewMoreClick={trackingProps => {
                trackViewMoreClick(trackingProps);
                trackModule(TRACKING_TITLE);
            }}
            trackItemClick={trackingProps => {
                trackItemClick({ ...trackingProps, variant: 'homepage' });
                trackModuleLocation({
                    label: 'recently viewed module',
                    moduleIndex,
                    totalModules,
                });
                trackModule(TRACKING_TITLE);
            }}
            trackItemImpression={trackingProps => {
                trackItemImpression({ ...trackingProps, variant: 'homepage' });
            }}
            onInitialDisplay={({ items }) => {
                trackInitialDisplay({ itemsReturned: items.length, actionLabel: ACTION_LABEL });
            }}
            currency={currency}
            isBot={isBot}
        />
    );
};
